import { render, staticRenderFns } from "./ReportManagement.vue?vue&type=template&id=26945741&"
import script from "./ReportManagement.vue?vue&type=script&lang=ts&"
export * from "./ReportManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports